import React, { Component, useState, Suspense, lazy, useEffect } from "react";
import {
  BrowserRouter,
  Switch,
  Route,
} from "react-router-dom";
import Imucor from './imucor'
import Cohort from './cohort'
export default function Main() {
    return (
      <BrowserRouter>
        <Switch>
          <Route exact path="/" component={Imucor} />
          <Route exact path="/cohort" component={Cohort} />
        </Switch>
      </BrowserRouter>
    );
}
